import { getOnBoardingDeleteVisible } from '../utils/localStorage';
export var selectIsShowOnBoardingDelete = function selectIsShowOnBoardingDelete(state) {
  return Boolean(getOnBoardingDeleteVisible() && state.favoritesAssignWidget.showOnBoardingDelete);
};